import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomContactUsComponent} from './custom-contact-us.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from "@spartacus/core";
import {ReactiveFormsModule} from "@angular/forms";
import {FormErrorsModule} from "@spartacus/storefront";
import {CustomIconsModule} from "../../../icons/custom-icons.module";
import {CustomFileUploaderModule} from "../../../forms/file-uploader/custom-file-uploader.module";
import {RouterModule} from "@angular/router";


@NgModule({
  declarations: [CustomContactUsComponent],
    imports: [
        CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ContactUsFormComponent: {
                    component: CustomContactUsComponent,
                },
            },
        } as CmsConfig),
        I18nModule,
        ReactiveFormsModule,
        FormErrorsModule,
        CustomIconsModule,
        CustomFileUploaderModule,
        RouterModule,
        UrlModule,
    ]
})
export class CustomContactUsModule { }
